import OadpCard from './oadp-card';
export default OadpCard;
